export const API_URL = process.env.REACT_APP_API_URL;

async function request(path, { method = "GET", body } = {}) {
  const options = { method, headers: {} };
  if (body !== undefined) {
    options.headers["Content-Type"] = "application/json";
    options.body = JSON.stringify(body);
  }
  let res;
  try {
    res = await fetch(`${API_URL}${path}`, options);
  } catch {
    throw new Error("No se pudo conectar con la API. ¿Está levantada en " + API_URL + "?");
  }
  if (!res.ok) {
    let detail = `Error ${res.status}`;
    try {
      const data = await res.json();
      if (data && data.detail) {
        detail = Array.isArray(data.detail)
          ? data.detail.map((d) => d.msg).join(", ")
          : data.detail;
      }
    } catch {
      /* sin cuerpo JSON */
    }
    throw new Error(detail);
  }
  if (res.status === 204) return null;
  return res.json();
}

function buildQuery(params) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      qs.set(key, value);
    }
  });
  const str = qs.toString();
  return str ? `?${str}` : "";
}

export const api = {
  getClientes: async (params = {}) =>
    request(`/api/clientes${buildQuery(params)}`),

  createCliente: async (data) =>
    request("/api/clientes", { method: "POST", body: data }),

  getSucursales: async (params = {}) =>
    request(`/api/sucursales${buildQuery(params)}`),

  getSucursal: async (id) =>
    request(`/api/sucursales/${id}`),

  createSucursal: async (data) =>
    request("/api/sucursales", { method: "POST", body: data }),

  updateSucursal: async (id, data) =>
    request(`/api/sucursales/${id}`, { method: "PUT", body: data }),

  deleteSucursal: async (id) =>
    request(`/api/sucursales/${id}`, { method: "DELETE" }),

  getConexion: async (sucursalId) =>
    request(`/api/sucursales/${sucursalId}/conexion`),

  updateConexion: async (sucursalId, data) =>
    request(`/api/sucursales/${sucursalId}/conexion`, { method: "PUT", body: data }),

  // Sin `llave` genera una nueva e invalida la anterior. Con `llave` fija una
  // propia (UUID, NEB-XXXX-XXXX o la que emita tu plataforma).
  rotarLlave: async (sucursalId, llave) =>
    request(`/api/sucursales/${sucursalId}/llave`, {
      method: "POST",
      body: llave ? { llave } : undefined,
    }),

  getRoles: async () =>
    request("/api/roles"),

  getPermisos: async () =>
    request("/api/permisos"),

  createPermiso: async (data) =>
    request("/api/permisos", { method: "POST", body: data }),

  updatePermiso: async (id, data) =>
    request(`/api/permisos/${id}`, { method: "PUT", body: data }),

  deletePermiso: async (id) =>
    request(`/api/permisos/${id}`, { method: "DELETE" }),

  getCuentas: async (params = {}) =>
    request(`/api/cuentas${buildQuery(params)}`),

  createCuenta: async (data) =>
    request("/api/cuentas", { method: "POST", body: data }),

  updateCuenta: async (id, data) =>
    request(`/api/cuentas/${id}`, { method: "PUT", body: data }),

  deleteCuenta: async (id) =>
    request(`/api/cuentas/${id}`, { method: "DELETE" }),

  getPaquetes: async () =>
    request("/api/paquetes"),

  createPaquete: async (data) =>
    request("/api/paquetes", { method: "POST", body: data }),

  updatePaquete: async (id, data) =>
    request(`/api/paquetes/${id}`, { method: "PUT", body: data }),

  deletePaquete: async (id) =>
    request(`/api/paquetes/${id}`, { method: "DELETE" }),

  getSuscripciones: async () =>
    request("/api/suscripciones"),

  getHistorialPagos: async () =>
    request("/api/pagos/historial"),

  registrarPago: async (data) =>
    request("/api/suscripciones/pagar", { method: "POST", body: data }),

  updateSuscripcion: async (branchId, data) =>
    request(`/api/suscripciones/${branchId}`, { method: "PUT", body: data }),
};